import {
  ChangeDetectorRef,
  Component,
  Inject,
  OnInit,
  effect,
  inject,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

import {
  GetEnumValuesDto,
  SendTypes,
  SmartScheduledMessageCalculationsDto,
} from "src/app/core/api/models";
import { AppStateService } from "src/app/core/services/app-state.service";
import { AppThemeMode } from "src/app/core/types/app-theme-mode.type";

@Component({
    selector: "app-smart-send-sms-confirmation",
    templateUrl: "./smart-send-sms-confirmation.component.html",
    styleUrls: ["./smart-send-sms-confirmation.component.scss"],
    standalone: false
})
export class SmartSendSmsConfirmationComponent implements OnInit {
  appStateService = inject(AppStateService);
  pageVocabs = "pages.sendQueue.fields.";

  model: Array<SmartScheduledMessageCalculationsDto>;
  sendType: SendTypes;
  SmsAggregatorsEnumValues: GetEnumValuesDto[] = [];
  theme: AppThemeMode;
  rightelImage: string;
  mciImage: string;

  get SendTypes() {
    return SendTypes;
  }
  constructor(
    private dialogRef: MatDialogRef<SmartSendSmsConfirmationComponent>,
    private cd: ChangeDetectorRef,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.model = data?.model;
    this.sendType = data?.sendType;
    this.SmsAggregatorsEnumValues = data?.smsAggregators;
    effect(() => {
      this.mciImage =
        this.appStateService.currentThemeMode() == "dark"
          ? "/assets/media/svg/operator/mci-dark.svg"
          : "/assets/media/svg/operator/mci.svg";
      this.rightelImage =
        this.appStateService.currentThemeMode() == "dark"
          ? "/assets/media/svg/operator/rightel-dark.svg"
          : "/assets/media/svg/operator/rightel.svg";
    });
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    this.cd.detectChanges();
  }

  onClose() {
    this.dialogRef.close(false);
  }

  onSubmit() {
    this.dialogRef.close(true);
  }
}
